window.quickViewCache = {};

const menuDrawerTab = document.querySelectorAll('[js-click-add-class]');
const menuDrawerClose = document.querySelectorAll('[js-click-back]');

menuDrawerTab.forEach((tab) => {
  tab.addEventListener('click', function (e) {
    if (e.target.closest('[js-click-back]')) return;

    if (!tab.classList.contains('open-menu')) {
      tab.classList.add('open-menu');
    }
  });
});

menuDrawerClose.forEach((closeBtn) => {
  closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    const parentTab = closeBtn.closest('[js-click-add-class]');
    if (parentTab) {
      parentTab.classList.remove('open-menu');
    }
  });
});

// Terms & conditions popup code starts here

const termsPopupWrapper = document.getElementById('terms-condition-popup');
termsPopupWrapper?.addEventListener('click', function () {
  document.body.classList.remove('terms-popup--opened');
});

const termsPopup = document.querySelector('.terms-condition__modal');
termsPopup?.addEventListener('click', function (event) {
  event.stopPropagation();
});

const termsPopupClose = document.querySelector('.terms-condition__modal-close');
termsPopupClose?.addEventListener('click', function () {
  document.body.classList.remove('terms-popup--opened');
});

// Terms & conditions popup code ends here

function initializePriceRangeSliders() {
  // Custom Range slider for price fields on filter drawer
  const priceRangeContainers = document.querySelectorAll('.price-range');
  priceRangeContainers.forEach((priceRangeContainer) => {
    const sliderElement = priceRangeContainer.querySelector('.price-range__slider');
    const displayMinElement = priceRangeContainer.querySelector('.price-range__display-min');
    const displayMaxElement = priceRangeContainer.querySelector('.price-range__display-max');
    const inputMinElement = priceRangeContainer.querySelector('.price-range__input-min');
    const inputMaxElement = priceRangeContainer.querySelector('.price-range__input-max');

    const currencySymbol = priceRangeContainer.dataset.currencySymbol || '$';
    const minRange = parseFloat(priceRangeContainer.dataset.min) || 0;
    const maxRange = parseFloat(priceRangeContainer.dataset.max) || 100;
    const minValue = parseFloat(priceRangeContainer.dataset.minValue) || minRange;
    const maxValue = parseFloat(priceRangeContainer.dataset.maxValue) || maxRange;
    // const maxValue = 290;

    // Prevent initializing the slider again if it already exists
    if (sliderElement.noUiSlider) {
      // console.log('Slider already initialized, skipping:', sliderElement);
      return;
    }

    noUiSlider.create(sliderElement, {
      start: [minValue, maxValue],
      connect: true,
      range: {
        min: minRange,
        max: maxRange,
      },
      step: 10,
    });

    sliderElement.noUiSlider.on('update', (values) => {
      displayMinElement.textContent = `${currencySymbol}${values[0]}`;
      displayMaxElement.textContent = `${currencySymbol}${values[1]}`;
      inputMinElement.value = values[0];
      inputMaxElement.value = values[1];
    });

    // Redirect with updated query parameters when slider range is changed
    sliderElement.noUiSlider.on('change', (values) => {
      const min = parseFloat(values[0]).toFixed(2);
      const max = parseFloat(values[1]).toFixed(2);

      // Get current URL and construct new URL with updated query parameters
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('filter.v.price.gte', min);
      currentUrl.searchParams.set('filter.v.price.lte', max);

      // Redirect to the updated URL
      window.location.href = currentUrl.toString();
    });
  });
}
initializePriceRangeSliders();

document.addEventListener('DOMContentLoaded', function () {
  const shopByBrandContainer = document.querySelector('[js-shop-by-brand]');
  const tabs = Array.from(document.querySelectorAll('[js-tab-header]'));

  const shopByBrandDrawer = document.querySelector('.drawer_menu');
  const mobileAccordions = shopByBrandDrawer && Array.from(shopByBrandDrawer.querySelectorAll('[js-drawer-tab-header]'));

  // Mobile
  mobileAccordions &&
    mobileAccordions.forEach((item) => {
      item.addEventListener('click', function ({ currentTarget }) {
        mobileAccordions.forEach((elm) => {
          if (!elm.contains(currentTarget)) {
            elm.classList.contains('active') ? elm.classList.remove('active') : '';
          }
        });
        currentTarget.classList.toggle('active');
      });
    });

  // Desktop

  tabs.forEach((item) => {
    item.addEventListener('click', function ({ currentTarget }) {
      tabs.forEach((itm) => (itm.classList.contains('selected') ? itm.classList.remove('selected') : ''));
      !currentTarget.classList.contains('selected') ? currentTarget.classList.add('selected') : '';

      const parent = currentTarget.closest('[js-shop-by-brand]');
      const contentWrapper = currentTarget.closest('[js-item-wrap]');
      const firstHalf = contentWrapper.querySelector('[js-first-half]').cloneNode(true);
      const secondHalf = contentWrapper.querySelector('[js-second-half]').cloneNode(true);

      const contentElemFirst = parent.querySelector('[js-tab-detail-content-first]');
      const contentElemSecond = parent.querySelector('[js-tab-detail-content-second]');
      contentElemFirst.innerHTML = '';
      contentElemSecond.innerHTML = '';
      contentElemFirst.appendChild(firstHalf);
      contentElemSecond.appendChild(secondHalf);
    });
  });
  document.querySelector('[js-shop-by-brand] [js-tab-header]').click();

  // Shop by video fixing
  const shopByVideo = document.querySelector('[js-shop-by-video-wrapper]');
  const videoMenuItems = Array.from(shopByVideo.querySelectorAll('[js-shop-video-item'));

  const sBVElm = shopByVideo.querySelector('[js-sbv-video-item]');
  const wrapper_ = document.querySelector('[js-video-popup-modal]');
  wrapper_.querySelector('.cross_btn').addEventListener('click', function () {
    wrapper_.classList.add('hide');
    wrapper_.querySelector('.video_content').innerHTML = '';
    document.querySelector('.video__popup-overlay').classList.add('hide');
  });
  document.querySelector('.video__popup-overlay').addEventListener('click', function () {
    wrapper_.classList.add('hide');
    wrapper_.querySelector('.video_content').innerHTML = '';
    document.querySelector('.video__popup-overlay').classList.add('hide');
    document.body.style.overflow = 'auto';
  });

  sBVElm.addEventListener('click', function ({ currentTarget }) {
    const videoPopup = wrapper_.querySelector('.video_content');

    const videoElm = currentTarget.querySelector('video').cloneNode(true);

    videoPopup.appendChild(videoElm) && videoPopup.querySelector('video').play();
    wrapper_.classList.contains('hide') ? wrapper_.classList.remove('hide') : '';
    document.querySelector('.video__popup-overlay.hide').classList.remove('hide');
    document.body.style.overflow = 'hidden';
  });
  const drawerCloseBtn = document.querySelector('[js-drawer-close-button]');
  if (drawerCloseBtn) {
    drawerCloseBtn.addEventListener('click', function ({ currentTarget }) {
      const mainMenu = currentTarget.closest('header-drawer');
      const mainMenuSummary = mainMenu.querySelector('summary.header__icon.header__icon--menu.header__icon--summary');

      if (mainMenuSummary) {
        mainMenuSummary.click();
      }
    });
  }

  // Quick View Modal

  function initQuickShop() {
    var ids = [];
    var products = document.querySelectorAll('[js-quick-view-button]');
    // also include check for theme settings whether quick view is enabled or not
    if (!products.length) {
      return;
    }

    products.forEach((product) => {
      product.addEventListener('mouseover', productMouseOver);
      product.addEventListener('focusin', productMouseOver);
      product.addEventListener('click', showPopupModal);
    });

    function showPopupModal(evt) {
      console.log('show popup 1');
      evt.preventDefault();
      evt.stopPropagation();
      console.log('show popup 2');
      const { currentTarget } = evt;
      const el = currentTarget.closest('.grid-product');

      const productId = el.dataset.productId;
      const productHandle = el.dataset.productHandle;
      const btn = el.querySelector('.quick-product__btn');

      fetchProduct(productHandle, productId, btn);
    }

    function fetchProduct(handle, productId, btn) {
      const holder = document.getElementById('QuickShopHolder-' + handle);
      let url = Shopify.routes.root + 'products/' + handle;

      // remove double `/` in case shop might have /en or language in URL
      url = url.replace('//', '/');

      function initializer(text) {
        const html = document.createElement('div');
        html.innerHTML = text;
        const div = html.querySelector('product-info');
        div.dataset.updateUrl = 'false';
        if (!holder) {
          return;
        }

        holder.innerHTML = '';
        holder.append(div);
        const quickViewModal = holder.closest('.modal.modal--quick-shop');
        if (quickViewModal.closest(".featured-products")) {
          const customQuickview = document.querySelector(".custom-quickview");
          customQuickview.innerHTML = "";
          customQuickview.appendChild(quickViewModal);
          customQuickview.classList.remove("hidden");
        }

        !quickViewModal.classList.contains('active') ? quickViewModal.classList.add('active') : '';

        const crossButton = quickViewModal.querySelector('.modal__close.js-modal-close');
        crossButton.addEventListener('click', function () {
          console.log({ holder });
          const modalContainer = holder.closest(`#QuickShopModal-${productId}`);
          modalContainer.classList.contains('active') ? modalContainer.classList.remove('active') : '';
          holder.innerHTML = '';
          let customQuickView = modalContainer.closest(".custom-quickview");
          if (customQuickView) {
            customQuickView.classList.add("hidden");
            let section = customQuickView.closest(".shopify-section");
            let productCard = section.querySelector(`.product__grid-item[data-product-id="${productId}"]`);
            productCard.appendChild(modalContainer);
          }
        });
        document.querySelector('.modal.modal--quick-shop.active .overlay').addEventListener('click', function (evt) {
          const quickShopModal = document.querySelector('.modal.modal--quick-shop.active');
          if (quickShopModal) {
            const productHandle = quickShopModal.dataset.productHandle;
            const holder = quickShopModal.querySelector(`#QuickShopHolder-${productHandle}`);

            quickShopModal.classList.remove('active');
            let customQuickView = quickShopModal.closest(".custom-quickview");
            if (customQuickView) {
              customQuickView.classList.add("hidden");
              let section = customQuickView.closest(".shopify-section");
              let productCard = section.querySelector(`.product__grid-item[data-product-id="${productId}"]`);
              productCard.appendChild(quickShopModal);
            }
          }
        });
        // initialize  slider
        document.dispatchEvent(new CustomEvent('pdpMediaSlider:init'));
        // Setup quick view modal
        var modalId = 'QuickShopModal-' + productId;
        var name = 'quick-modal-' + productId;

        if (btn) {
          btn.classList.remove('quick-product__btn--not-ready');
        }

        initPhotoSwipe(true);
        setThumbsHeight();
        thumbHeightOnSlideChange();
      }
      if (window.quickViewCache[handle]) {
        initializer(window.quickViewCache[handle]);
      } else {
        fetch(url)
          .then((response) => response.text())
          .then(initializer);
      }
    }

    function productMouseOver(evt) {
      const { currentTarget } = evt;
      const el = currentTarget.closest('.grid-product');

      currentTarget.removeEventListener('mouseover', productMouseOver);
      currentTarget.removeEventListener('focusin', productMouseOver);
      // return in case if its mobile
      if (window.innerWidth <= 767) {
        return;
      }

      const productId = el.dataset.productId;
      const productHandle = el.dataset.productHandle;
      const btn = el.querySelector('.quick-product__btn');
      console.log({ productHandle }, { el });
      preloadProductModal(productHandle, productId, btn);
    }
  }
  initQuickShop();

  document.addEventListener('initQuickShop', initQuickShop);

  function initPhotoSwipe(quickView) {
    // Photo Swipe inside quick view

    const buildSelector = (baseSelector) => {
      return quickView ? `.modal--quick-shop ${baseSelector}` : baseSelector;
    };

    const photo_swipe_buttons = document.querySelectorAll(buildSelector('.product__photo-zoom'));
    const pswpElement = document.querySelector('.pswp');
    const QuickViewSlider = document.querySelectorAll('.swiper-container')[1]?.swiper;

    const items = Array.from(document.querySelectorAll(buildSelector('.photoswipe__img')), (img) => ({
      msrc: img.currentSrc || img.src,
      src: img.getAttribute('data-photoswipe-src') || img.currentSrc || img.src,
      w: parseInt(img.getAttribute('data-photoswipe-width')) || img.naturalWidth,
      h: parseInt(img.getAttribute('data-photoswipe-height')) || img.naturalHeight,
      el: img,
    }));

    photo_swipe_buttons.forEach((button) => {
      button.addEventListener('click', (e) => handlePhotoZoom(e.currentTarget));
    });

    function handlePhotoZoom(target) {
      const targetImg = target.previousElementSibling;
      const index = parseInt(targetImg.getAttribute('data-index'), 10) - 1;

      var options = {
        index: index,
        bgOpacity: 1,
        showHideOpacity: true,
        allowPanToNext: true,
        captionEl: false,
        closeOnScroll: false,
        counterEl: true,
        history: false,
        pinchToClose: true,
        imageClickAction: 'close',
        loop: true,
        preloaderEl: false,
        getThumbBoundsFn: function (index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var thumbnail = items[index].el;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      };
      const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
      // Initialize the gallery
      gallery.listen('afterChange', function () {
        QuickViewSlider.slideTo(gallery.getCurrentIndex());
      });
    }
  }

  initPhotoSwipe(false);

  function preloadProductModal(handle, productId, btn) {
    const holder = document.getElementById('QuickShopHolder-' + handle);
    let url = Shopify.routes.root + 'products/' + handle;

    console.log({ url });
    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        window.quickViewCache[handle] = text;
      });
  }

  (function () {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]',
    };

    var classes = {
      listVisible: 'disclosure-list--visible',
    };

    // Main function to initialize a disclosure instance
    function initializeDisclosure(disclosure) {
      var disclosureData = cacheSelectors(disclosure);
      setupListeners(disclosure, disclosureData);
      return disclosureData; // Return disclosureData to allow manipulation if needed
    }

    // Function to cache the necessary DOM elements
    function cacheSelectors(disclosure) {
      return {
        disclosureForm: disclosure.closest(selectors.disclosureForm),
        disclosureList: disclosure.querySelector(selectors.disclosureList),
        disclosureToggle: disclosure.querySelector(selectors.disclosureToggle),
        disclosureInput: disclosure.querySelector(selectors.disclosureInput),
        disclosureOptions: disclosure.querySelectorAll(selectors.disclosureOptions),
      };
    }

    // Function to set up event listeners
    function setupListeners(disclosure, disclosureData) {
      var eventHandlers = setupEventHandlers(disclosureData);

      disclosureData.disclosureToggle.addEventListener('click', eventHandlers.toggleList);

      disclosureData.disclosureOptions.forEach(function (disclosureOption) {
        disclosureOption.addEventListener('click', eventHandlers.connectOptions);
      });

      disclosure.addEventListener('keyup', eventHandlers.onDisclosureKeyUp);

      disclosureData.disclosureList.addEventListener('focusout', eventHandlers.onDisclosureListFocusOut);

      disclosureData.disclosureToggle.addEventListener('focusout', eventHandlers.onDisclosureToggleFocusOut);

      document.body.addEventListener('click', eventHandlers.onBodyClick);
    }

    // Function to set up event handlers
    function setupEventHandlers(disclosureData) {
      return {
        connectOptions: function (event) {
          event.preventDefault();
          submitForm(disclosureData, event.currentTarget.dataset.value);
        },
        toggleList: function () {
          toggleList(disclosureData);
        },
        onDisclosureKeyUp: function (event) {
          onDisclosureKeyUp(disclosureData, event);
        },
        onDisclosureListFocusOut: function (event) {
          onDisclosureListFocusOut(disclosureData, event);
        },
        onDisclosureToggleFocusOut: function (event) {
          onDisclosureToggleFocusOut(disclosureData, event);
        },
        onBodyClick: function (event) {
          onBodyClick(disclosureData, event);
        },
      };
    }

    // Handle form submission
    function submitForm(disclosureData, value) {
      disclosureData.disclosureInput.value = value;
      disclosureData.disclosureForm.submit();
    }

    // Handle toggling the list visibility
    function toggleList(disclosureData) {
      var ariaExpanded = disclosureData.disclosureToggle.getAttribute('aria-expanded') === 'true';
      disclosureData.disclosureList.classList.toggle(classes.listVisible);
      disclosureData.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
    }

    // Hide the disclosure list
    function hideList(disclosureData) {
      disclosureData.disclosureList.classList.remove(classes.listVisible);
      disclosureData.disclosureToggle.setAttribute('aria-expanded', false);
    }

    // Keyup handler for hiding the list when escape key is pressed
    function onDisclosureKeyUp(disclosureData, event) {
      if (event.which !== 27) return;
      hideList(disclosureData);
      disclosureData.disclosureToggle.focus();
    }

    // Handle focus out for the toggle
    function onDisclosureToggleFocusOut(disclosureData, event) {
      var disclosureLostFocus = disclosureData.container.contains(event.relatedTarget) === false;
      if (disclosureLostFocus) {
        hideList(disclosureData);
      }
    }

    // Handle focus out for the disclosure list
    function onDisclosureListFocusOut(disclosureData, event) {
      var childInFocus = event.currentTarget.contains(event.relatedTarget);
      var isVisible = disclosureData.disclosureList.classList.contains(classes.listVisible);

      if (isVisible && !childInFocus) {
        hideList(disclosureData);
      }
    }

    // Handle clicks outside the disclosure component
    function onBodyClick(disclosureData, event) {
      var isOption = disclosureData.disclosureForm.contains(event.target);
      var isVisible = disclosureData.disclosureList.classList.contains(classes.listVisible);

      if (isVisible && !isOption) {
        hideList(disclosureData);
      }
    }

    // Expose the initialization function
    window.initializeDisclosure = initializeDisclosure;
  })();
  var disclosureContainer = document.querySelector('[data-disclosure-locale]');
  if(disclosureContainer){
    initializeDisclosure(disclosureContainer);
  }

  // footer accordion
  const accordionButtons = document.querySelectorAll('.site-footer .collapsible-trigger-btn');

  accordionButtons.forEach((elm) => {
    elm.addEventListener('click', function () {
      const item = this.parentElement;
      let content = elm.nextElementSibling;
      if (item.classList.contains('active')) {
        content.style.height = '0px';
      } else {
        content.style.height = '';
        const contentHeight = content.querySelector('.collapsible-content__inner').scrollHeight;
        content.style.height = `${contentHeight}px`;
      }
      item.classList.toggle('active');
    });
  });

  function initPDPMediaSlider() {
    const thumbSliders = document.querySelectorAll('[js-product-thumb-slider]');
    const mediaSliders = document.querySelectorAll('[js-product-media-slider]');

    thumbSliders.forEach((thumbSlider, index) => {
      // Get the corresponding media slider
      const mediaSlider = mediaSliders[index];

      // Ensure a matching media slider exists
      if (!mediaSlider) {
        console.warn(`No matching media slider found for thumb slider at index ${index}`);
        return;
      }

      // Initialize the thumb slider
      const sliderThumbs = new Swiper(thumbSlider, {
        direction: 'vertical',
        slidesPerView: 7,
        spaceBetween: 15,
        freeMode: true,
        breakpoints: {
          0: {
            direction: 'horizontal',
          },
          768: {
            direction: 'vertical',
          },
        },
      });

      // Initialize the media slider
      new Swiper(mediaSlider, {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        autoHeight: true,
        spaceBetween: 0,
        mousewheel: false,
        grabCursor: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        thumbs: {
          swiper: sliderThumbs,
        },
      });
    });
  }

  // Initialize the sliders on load
  initPDPMediaSlider();

  // Reinitialize sliders when the custom event is triggered
  document.addEventListener('pdpMediaSlider:init', initPDPMediaSlider);

  // // For back button
  // const productInfoSection = document.querySelector('product-info');
  // const height = productInfoSection.offsetHeight

  // const productInfoObserver = new window.IntersectionObserver(([entry]) => {
  //   console.log(entry.boundingClientRect.top, ' top' )
  //   if(entry.isIntersecting) {
  //     console.log("intersecting..!")
  //   }

  //   if((entry.boundingClientRect.top + height) <= 1) {
  //     console.log("pas")
  //   } else {
  //     console.log("reached")
  //   }
  // })
  // productInfoObserver.observe(productInfoSection)

  var handlerFired;
  window.addEventListener('scroll', function (e) {
    var containerPDPInfo = document.querySelector('product-info');
    if (containerPDPInfo) {
      var containerTop = document.querySelector('product-info').getBoundingClientRect().top;
      if (containerTop <= 0) {
        if (!handlerFired) {
          handlerFired = 1;
          containerPDPInfo.classList.add('pdp_info-top');
        }
      }
      if (containerTop > 0) {
        handlerFired = 0;
        containerPDPInfo.classList.remove('pdp_info-top');
      }
    }
  });
  /*============================================================================
    CountdownTimer
  ==============================================================================*/

  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]');
      this.block = this.closest('.countdown__block--timer');
      this.year = this.el.dataset.year;
      this.month = this.el.dataset.month;
      this.day = this.el.dataset.day;
      this.hour = this.el.dataset.hour;
      this.minute = this.el.dataset.minute;
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
      this.hideTimerOnComplete = this.el.dataset.hideTimer;
      this.completeMessage = this.el.dataset.completeMessage;

      this.timerComplete = false;

      this.init();
    }

    init() {
      setInterval(() => {
        if (!this.timerComplete) {
          this._calculate();
        }
      }, 1000);
    }

    _calculate() {
      // Find time difference and convert to integer
      const timeDifference =
        +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
      // If time difference is greater than 0, calculate remaining time
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDifference / 1000 / 60) % 60),
          seconds: Math.floor((timeDifference / 1000) % 60),
        };

        this.daysPlaceholder.innerHTML = intervals.days;
        this.hoursPlaceholder.innerHTML = intervals.hours;
        this.minutesPlaceholder.innerHTML = intervals.minutes;
        this.secondsPlaceholder.innerHTML = intervals.seconds;

        setTimeout(() => {
          this.display.classList.add('countdown__display--loaded');
        }, 1);
      } else {
        if (this.completeMessage && this.messagePlaceholder) {
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }

        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }

        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }

        this.timerComplete = true;
      }
    }
  }

  customElements.define('countdown-timer', CountdownTimer);

  // to close all opened details when a summary is clicked
  function handleDetailsToggle(event) {
    const allDetails = document.querySelectorAll('.product__accordion.accordion details');

    // If the clicked <details> is opened, close all others
    if (event.target.open) {
      allDetails.forEach((detail) => {
        // Close all details except the one that was clicked
        if (detail !== event.currentTarget && detail.open) {
          detail.removeAttribute('open');
        }
      });
    }
  }

  //Attach the event listener to each <details> element
  document.querySelectorAll('.product__accordion.accordion details').forEach((detail) => {
    detail.addEventListener('toggle', handleDetailsToggle);
  });

  const summaries = document.querySelectorAll('details:has( .summary__title)');
  summaries.forEach((summary) => {
    summary.addEventListener('toggle', (ev) => {
      if (summary.open) window.scrollTo({ top: summary.getBoundingClientRect().top + window.scrollY - 250, behavior: 'smooth' });
    });
  });

  const allSearchModals = document.querySelectorAll('.search-modal.modal__content');
  allSearchModals.forEach((item) => {
    item.addEventListener('click', function (evt) {
      const { currentTarget } = evt;
      const form_ = currentTarget.querySelector('form');
      const closeBtn = currentTarget.querySelector('.search-modal__close-button.modal__close-button');

      if (!evt.target.closest('form')) {
        closeBtn.click();
      }
    });
  });

  // Wrap video iframe embeds so they are responsive
  document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach((iframe) => {
    wrapVideo(iframe);
  });
  document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach((iframe) => {
    wrapVideo(iframe);
  });

  // function wrapVideo(iframe) {
  //   // Reset the src attribute on each iframe after page load
  //   // for Chrome's "incorrect iFrame content on 'back'" bug.
  //   // https://code.google.com/p/chromium/issues/detail?id=395791
  //   iframe.src = iframe.src;

  //   // Create the wrapper element
  //   const wrapWith = document.createElement('div');
  //   wrapWith.classList.add('video-wrapper');

  //   // Wrap the iframe with the wrapper
  //   iframe.parentNode.insertBefore(wrapWith, iframe);
  //   wrapWith.appendChild(iframe);
  // }
  // Header Smooth Sticky
  function applyStickyHeaderHeight() {
    // Select the sticky header section element
    const stickyHeaderSection = document.querySelector('.shopify-section.header-section');
    const stickyHeaderWrapper = document.querySelector('sticky-header.header-wrapper');

    if (stickyHeaderSection) {
      // Check if the 'scrolled-past-header' class exists
      if (stickyHeaderWrapper.classList.contains('site-header--stuck') && stickyHeaderWrapper) {
        // Remove previously set height to allow recalculation
        stickyHeaderSection.style.minHeight = '';

        // Get the height of the .sticky-header.header-wrapper element
        const wrapperHeight = stickyHeaderWrapper.offsetHeight;
        stickyHeaderSection.style.minHeight = `${wrapperHeight}px`;
      } else {
        // Remove previously set height to allow recalculation
        stickyHeaderSection.style.minHeight = '';

        // Get the height of the .section-header element itself
        const innerHeight = stickyHeaderSection.offsetHeight;
        stickyHeaderSection.style.minHeight = `${innerHeight}px`;
      }
    }
  }

  // Apply the height initially
  applyStickyHeaderHeight();

  // Reapply the height on window resize
  window.addEventListener('resize', applyStickyHeaderHeight);


  // Remove overflow on drawer close
  const MobCloseButton = document.querySelector('.mobile-facets__close');
  if (MobCloseButton) {
    MobCloseButton.addEventListener('click', () => {
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    });
  } else {
    console.error('.mobile-facets__close button not found');
  }

  // Get a reference to the button
  const backButton = document.getElementById('dsktpBackBtn');

  if (backButton) {
    // Add an event listener to the window for the scroll event
    window.onscroll = function () {
      // Check if the page has been scrolled more than 150px
      if (window.scrollY > 250 && backButton.hasAttribute('data-enable-sticky')) {
        backButton.classList.add('btn-sticky');
      } else {
        backButton.classList.remove('btn-sticky');
      }
    };
  }

  // Change email icon to submit text
  var newsletterInput = document.querySelector('.footer__newsletter-input');
  if (newsletterInput) {
    newsletterInput.addEventListener('keyup', function () {
      newsletterInput.classList.add('footer__newsletter-input--active');
    });
  }

  // Set product thumb height
  function setThumbsHeight() {
    const allProductThumbs = document.querySelectorAll('.product__media-slider-thumb');
    allProductThumbs.forEach((thumbs) => {
      const imageWrapper = thumbs.nextElementSibling;
      thumbs.querySelector('.swiper-thumbs').style.height = `${imageWrapper.offsetHeight}px`;
    });
  }
  setThumbsHeight();

  function thumbHeightOnSlideChange() {
    let swiperWrappers = document.querySelectorAll('.product__media-image .swiper-initialized');
    if (swiperWrappers.length) {
      swiperWrappers.forEach((wrapper) => {
        wrapper.swiper.on('slideChangeTransitionEnd', setThumbsHeight);
      });
    }
  }
  thumbHeightOnSlideChange();
  window.addEventListener('resize', setThumbsHeight);


  // Collection Swatches
  function isOverflowing(element) {
    return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
  }

  function initializeFlickity(swatchContainer) {
    // --- Add check for initialization flag ---
    if (swatchContainer.dataset.flickityInitialized === 'true') {
      // Optionally force a resize if needed, but don't re-initialize fully
      if (swatchContainer.flickityInstance) {
        swatchContainer.flickityInstance.resize();
      }
      return; // Already initialized
    }

    // Check if Flickity is already initialized (redundant with the flag, but safe)
    if (swatchContainer.flickityInstance) {
      // Destroy existing instance to prevent conflicts
      swatchContainer.flickityInstance.destroy();
      swatchContainer.flickityInstance = null; // Clear the reference
    }

    if (isOverflowing(swatchContainer)) {
      // --- Move log here ---
      console.log('initializing flickity for:', swatchContainer);
      // Store the instance reference
      swatchContainer.flickityInstance = new Flickity(swatchContainer, {
        pageDots: false,
        cellAlign: 'left', // Use left align usually better for swatches unless centering is desired
        contain: true,
        prevNextButtons: true, // Consider setting to false if space is tight
        draggable: true,
        wrapAround: false,
        groupCells: true, // 'true' or a number like 3 or 4 might be better
        adaptiveHeight: true,
        resize: true,
        freeScroll: true // Allows smoother scrolling without snapping strictly to cells
      });
      
      updateArrowVisibility(swatchContainer.flickityInstance);

      window.addEventListener('resize', () => {
        swatchContainer.flickityInstance.resize();  // recalc layout
        updateArrowVisibility(swatchContainer.flickityInstance);
      });

      // Force a resize event to ensure proper initialization
      swatchContainer.flickityInstance.resize();
      // --- Set initialization flag ---
      swatchContainer.dataset.flickityInitialized = 'true';
    }
  }

  function updateArrowVisibility(flkty) {
    const prev = flkty.prevButton.element;
    const next = flkty.nextButton.element;

    if (prev.disabled && next.disabled) {
      prev.classList.add("hidden");
      next.classList.add("hidden");
    } else {
      prev.classList.remove("hidden");
      next.classList.remove("hidden");
    }
  }

  function handleSwatchClick(event) {
    event.preventDefault();
    const target = event.target;
    if (target.classList.contains('color-swatch')) {
      console.log('Swatch clicked:', target.dataset.color, 'Sold out class:', target.classList.contains('color-swatch--sold-out'));
      // adding and removing 'selected' class to color swatches
      const productId = target.dataset.productId;
      const productSwatchesContainer = target.closest(`.grid-product__colors--${productId}`);
      if (productSwatchesContainer) {
        const allProductSwatches = productSwatchesContainer.querySelectorAll('.color-swatch-wrapper');
        allProductSwatches.forEach(swatch => {
          swatch.classList.remove('selected');
        });
        let targetParent = target.closest(".color-swatch-wrapper");
        targetParent.classList.add('selected');
      }
      const gridItem = target.closest('.grid__item'); 
      // update image and URL on swatch click
      const targetImageSrc = target.dataset.variantImage;
      const mainImage = gridItem.querySelector('.grid__image-ratio image-element img, .image-wrap image-element img');
      if (mainImage && targetImageSrc) {
        mainImage.setAttribute('src', targetImageSrc);
        mainImage.setAttribute('srcset', targetImageSrc);
        // Update original image reference when a swatch is selected
        gridItem.dataset.originalImage = targetImageSrc;
        gridItem.dataset.originalSrcset = targetImageSrc;
      }
      const targetURL = target.dataset.variantUrl;
      const mainURL = gridItem.querySelector('.grid-product__link');
      if (mainURL && targetURL) {
        mainURL.setAttribute('href', targetURL);
      }
      // handle size selector - FIXED SECTION
      const colorValue = target.dataset.color;
      const allSizeSelectors = gridItem.querySelectorAll('.product__size-selector-value');
      if (allSizeSelectors.length > 0) {
        const colorScript = gridItem.querySelector(`script[data-color="${colorValue}"]`);
        if (colorScript) {
          const variants = JSON.parse(colorScript.textContent);
          // Reset all size selectors first
          allSizeSelectors.forEach(selector => {
            selector.classList.add('disabled');
            selector.removeAttribute('data-variant');
            selector.removeAttribute('js-variant-option-selector');
          });
          // Update available variants
          variants.forEach((variant, index) => {
            const variantID = variant.id;
            const available = variant.available;
             // Only update if the selector exists at this index
            if (variantID && allSizeSelectors[index]) {
              allSizeSelectors[index].dataset.variant = variantID;
              if (available) {
                allSizeSelectors[index].classList.remove('disabled');
                allSizeSelectors[index].setAttribute('js-variant-option-selector', '');
              } else {
                allSizeSelectors[index].classList.add('disabled');
              }
            }
          });
        }
      }
      // Handle sold out badge visibility based on variant availability
      const isAvailable = target.classList.contains('color-swatch--sold-out') === false;
      const soldOutTag = gridItem.querySelector('.grid-product__tag--high-priority');
      const tagWrapper = gridItem.querySelector('.grid-product__tag_wrap');

      if (!isAvailable) {
        console.log('Showing sold out badge');
        // Show sold out badge if variant is not available
        if (!soldOutTag) {
          // Create sold out badge if it doesn't exist
          const newSoldOutTag = document.createElement('div');
          newSoldOutTag.className = 'grid-product__tag grid-product__tag--high-priority sold--out';
          newSoldOutTag.textContent = window.theme?.strings?.soldOut || 'Sold out';

          // Clear existing category tags if sold out needs to be shown
          if (tagWrapper) {
            tagWrapper.innerHTML = '';
            tagWrapper.appendChild(newSoldOutTag);
          }
        }
      } else {
        // Remove sold out badge and restore original tags if variant is available
        console.log('Removing sold out badge or restoring tags');
        if (soldOutTag && tagWrapper) {
          // Remove the sold out tag
          soldOutTag.remove();

          // If tag wrapper is now empty, we need to restore category tags
          // This part could be extended to restore the original tags (would need to store them somewhere)
          if (tagWrapper.children.length === 0 && gridItem.dataset.originalTags) {
            tagWrapper.innerHTML = gridItem.dataset.originalTags;
          }
        }
      }
    }
  }

  function initializeCollectionSwatches() {
    // First handle any existing swatches on the page
    const allSwatchesContainers = document.querySelectorAll('.grid-product__colors:not([data-flickity-initialized="true"])'); // Only select uninitialized
    if (allSwatchesContainers.length) {
      allSwatchesContainers.forEach(swatchContainer => {
        // Store original tags for each product
        const gridItem = swatchContainer.closest('.grid__item');
        if (gridItem && !gridItem.dataset.originalTags) {
          const tagWrapper = gridItem.querySelector('.grid-product__tag_wrap');
          if (tagWrapper) {
            gridItem.dataset.originalTags = tagWrapper.innerHTML;
          }
        }

        initializeFlickity(swatchContainer);
        // Ensure click listener is only added once if needed, though delegation handles this well
        if (!swatchContainer.dataset.clickListenerAdded) {
          swatchContainer.addEventListener('click', handleSwatchClick);
          swatchContainer.dataset.clickListenerAdded = 'true';
        }
      });
    }

    // Then set up observer for product recommendations if it exists
    const recommendationsContainer = document.querySelector('product-recommendations');
    if (recommendationsContainer) {
      // Check if observer already exists to prevent duplicates if this function runs multiple times
      if (recommendationsContainer.dataset.observerAttached === 'true') return;

      console.log('Attaching observer to recommendationsContainer', recommendationsContainer);
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length) {
            // --- Process only newly added nodes ---
            mutation.addedNodes.forEach(node => {
              // Check if the added node itself is a container or contains them
              if (node.nodeType === Node.ELEMENT_NODE) { // Ensure it's an element
                const swatchesInNode = node.querySelectorAll('.grid-product__colors:not([data-flickity-initialized="true"])');
                if (swatchesInNode.length) {
                  console.log('Found swatches in added node:', node);
                  swatchesInNode.forEach(swatchContainer => {
                    // Store original tags for dynamically added products
                    const gridItem = swatchContainer.closest('.grid__item');
                    if (gridItem && !gridItem.dataset.originalTags) {
                      const tagWrapper = gridItem.querySelector('.grid-product__tag_wrap');
                      if (tagWrapper) {
                        gridItem.dataset.originalTags = tagWrapper.innerHTML;
                      }
                    }

                    initializeFlickity(swatchContainer);
                    // Add listener if not already added
                    if (!swatchContainer.dataset.clickListenerAdded) {
                      swatchContainer.addEventListener('click', handleSwatchClick);
                      swatchContainer.dataset.clickListenerAdded = 'true';
                    }
                  });
                }
                // Also check if the node *is* the container itself (less likely but possible)
                else if (node.matches('.grid-product__colors:not([data-flickity-initialized="true"])')) {
                  console.log('Added node is a swatch container:', node);

                  // Store original tags for the product
                  const gridItem = node.closest('.grid__item');
                  if (gridItem && !gridItem.dataset.originalTags) {
                    const tagWrapper = gridItem.querySelector('.grid-product__tag_wrap');
                    if (tagWrapper) {
                      gridItem.dataset.originalTags = tagWrapper.innerHTML;
                    }
                  }

                  initializeFlickity(node);
                  if (!node.dataset.clickListenerAdded) {
                    node.addEventListener('click', handleSwatchClick);
                    node.dataset.clickListenerAdded = 'true';
                  }
                }
              }
            });
          }
        });
      });

      observer.observe(recommendationsContainer, {
        childList: true,
        subtree: true,
      });
      // Mark that observer is attached
      recommendationsContainer.dataset.observerAttached = 'true';
    }
  }

  // Initialize on DOMContentLoaded
  initializeCollectionSwatches();

  // Reinitialize when facets are rendered
  document.addEventListener('facetFiltersRendered', initializeCollectionSwatches);
}); // End of DOMContentLoaded event listener

// Global event listener for price range
document.addEventListener('click', (event) => {
  if (document.querySelector('.price-range')) {
    initializePriceRangeSliders();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  initializeTooltip();
});

document.addEventListener('CartDrawerOpen', function () {
  setTimeout(function () {
    initializeTooltip();
  }, 500);
});

function initializeTooltip() {
  console.log('initializeTooltip');
  const tooltipButtons = document.querySelectorAll('.tooltip-icon');
  console.log('tooltipButtons', tooltipButtons);

  tooltipButtons.forEach(button => {
    if (!button.dataset.listenerAttached) {
      button.addEventListener('click', function (e) {
        e.stopPropagation();
        const tooltip = this.closest('.final-sale-wrapper').querySelector('.final-sale-tooltip');
        const allTooltips = document.querySelectorAll('.final-sale-tooltip');

        // Close all other tooltips
        allTooltips.forEach(t => {
          if (t !== tooltip) {
            t.classList.remove('active');
          }
        });
        tooltip.classList.toggle('active');
      });

      button.dataset.listenerAttached = 'true';
    }
  });

  // Close tooltip when clicking anywhere else on the page
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.final-sale-wrapper')) {
      document.querySelectorAll('.final-sale-tooltip').forEach(tooltip => {
        tooltip.classList.remove('active');
      });
    }
  });
}

// Quick Add to Cart Function
function quickAddToCart(variantID) {
  return new Promise((resolve, reject) => {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let formData = {
      'items': [{
        "id": variantID,
        "quantity": 1
      }]
    };

    if (cart) {
      formData.sections = cart.getSectionsToRender().map((section) => section.id);
      formData.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then(function (response) {
        if (response.status) {
          if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartError) {
            window.publish(window.PUB_SUB_EVENTS.cartError, {
              source: 'product-grid',
              productVariantId: variantID,
              errors: response.description,
              message: response.message
            });
          }
          reject(response);
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          resolve(response);
          return;
        }

        if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-grid',
            cartData: response,
            productVariantId: variantID
          });
        }

        cart.renderContents(response);

        // Handle drawer visibility and classes
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          const drawerFooter = cartDrawer.querySelector('.drawer__footer');
          if (drawerFooter) {
            drawerFooter.classList.remove('hidden');
          }
        }
        resolve(response);
      })
      .catch((error) => {
        console.error('Error:', error);
        if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartError) {
          window.publish(window.PUB_SUB_EVENTS.cartError, {
            source: 'product-grid',
            productVariantId: variantID,
            errors: error.message,
            message: error.message
          });
        }
        reject(error);
      });
  });
}

// Grid Product Size Selector
document.addEventListener('click', function (e) {
  const sizeSelector = e.target.closest('[js-variant-option-selector]');
  if (sizeSelector && sizeSelector.classList.contains('product__size-selector-value')) {
    e.preventDefault();
    e.stopPropagation();

    // Add loading state
    sizeSelector.style.opacity = '0.5';
    sizeSelector.style.pointerEvents = 'none';

    // Get the variant ID and add to cart
    const variantId = sizeSelector.dataset.variant;
    if (variantId) {
      quickAddToCart(variantId).then(() => {
        // Reset loading state
        setTimeout(() => {
          sizeSelector.style.opacity = '';
          sizeSelector.style.pointerEvents = '';
        }, 500);
      }).catch(() => {
        // Reset on error
        sizeSelector.style.opacity = '';
        sizeSelector.style.pointerEvents = '';
      });
    }
  }
});

// Product Size Selector open/close
document.addEventListener('click', function (e) {
  const sizePlusIcons = document.querySelectorAll('.product__size-selector-plus');
  const sizeCloseIcons = document.querySelectorAll('.product__size-selector-close');
  sizePlusIcons.forEach(icon => {
    icon.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const sizeSelector = icon.closest('.product__size-selector-wrap');
      sizeSelector.classList.add('open');
    });
  });

  sizeCloseIcons.forEach(icon => {
    icon.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const sizeSelector = icon.closest('.product__size-selector-wrap');
      sizeSelector.classList.remove('open');
    });
  });
});

// Helper function to update cart count
function updateCartCount() {
  fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(r => r.json())
    .then(cartData => {
      document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(el => {
        el.textContent = cartData.item_count;
        if (cartData.item_count > 0) {
          el.closest('.cart-count-bubble')?.classList.remove('cart-count-bubble--empty');
        }
      });
    })
    .catch(error => console.error('Failed to update cart count:', error));
}



// Wait for _swat to be available
(function waitForSwat() {
  if (window._swat && window._swat.evtLayer) {
    _swat.evtLayer.addEventListener('sw:addedtocart', (e) => {
      console.log('Swym added to cart:', e.detail.d.productData);
      
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (!cart) return;
      
      // Get required sections
      const sectionsToRender = cart.getSectionsToRender();
      const sectionIds = sectionsToRender.map(section => section.section || section.id);
      
      // Fetch sections and cart data in parallel
      Promise.all([
        fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(r => r.json()),
        
        fetch('/cart.js', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(r => r.json())
      ])
      .then(([sections, cartData]) => {
        // Update cart UI
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          const drawerFooter = cartDrawer.querySelector('.drawer__footer');
          if (drawerFooter) {
            drawerFooter.classList.remove('hidden');
          }
        }
        cart.renderContents({ ...cartData, sections });
        
        // Publish update event
        if (window.PUB_SUB_EVENTS?.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'swym',
            cartData: { ...cartData, sections },
            productVariantId: e.detail.d.productData.id
          });
        }
      })
      .catch(error => {
        console.error('Error updating cart UI after Swym add to cart:', error);
        updateCartCount(); // Simple fallback
      });
    });
  } else {
    setTimeout(waitForSwat, 200);
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('usShippingUpdateModalOverlay');
  const closeBtn = document.getElementById('usShippingUpdateCloseModal');

  // Utility: Set cookie
  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  // Utility: Get cookie
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  // Check if user has already seen the modal
  const hasSeenModal = getCookie('usshipping_seen');

  if (!hasSeenModal) {
    // Show modal after 2 seconds
    setTimeout(() => {
      overlay.classList.add('active');
      setCookie('usshipping_seen', 'true', 10); // Set cookie for 10 days
      console.log('Modal shown and cookie set');
    }, 2000);
  } else {
    console.log('Modal skipped due to existing cookie');
  }

  // Close on X click
  closeBtn.addEventListener('click', () => overlay.classList.remove('active'));

  // Close when clicking outside modal
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.classList.remove('active');
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') overlay.classList.remove('active');
  });
});




document.addEventListener("DOMContentLoaded", function () {
  const targetSelector = ".grid-product__colors";

  function updateSwatches() {
    document.querySelectorAll(targetSelector).forEach(el => {
      const flickityParent = el.closest(".flickity-slider");
      if (flickityParent && flickityParent.offsetParent !== null) {
        // offsetParent !== null means element is visible
        el.classList.add("swatches-visible");
      }
    });
  }

  // Keep checking every 100ms until found
  const checkInterval = setInterval(() => {
    updateSwatches();
    if (document.querySelector(`${targetSelector}.swatches-visible`)) {
      clearInterval(checkInterval); // stop once class is added to at least one
    }
  }, 100);

  // Also observe DOM for new elements
  const observer = new MutationObserver(updateSwatches);
  observer.observe(document.body, { childList: true, subtree: true });
});